<div class="flex justify-end items-center box-border">
  <button mat-icon-button
          class="text-neutral-variant-40 iconButtonReducedDensity mx-1"
          (click)="sizeColumnsToFit()"
          matTooltip="Adjust visible columns in size to fit available horizontal space">
    <mat-icon svgIcon="resize_columns"></mat-icon>
  </button>

  <button mat-icon-button
          class="text-neutral-variant-40 iconButtonReducedDensity mx-1"
          (click)="resetTableLayout()"
          matTooltip="Restore default column settings"
          appGtagEvent
          trackOn="click"
          action="Apply default CC columns"
          category="Adapt column display [overhaul]"
          [params]="{event_label: 'Apply default CC columns'}">
    <mat-icon svgIcon="reset_columns"></mat-icon>
  </button>
</div>